export default __webpack_public_path__ + "static/media/silverware.ec175b26.svg";